<label class="subHeading">MMV</label>
<app-autocomplete-field
    [controlName]="controlName"
    [config]="autoCompleteFieldOptions"
>
</app-autocomplete-field>